module.exports = __webpack_public_path__ + "svg/new-interac-small.f3a4f692f8b830b2dc5f6f1531e1f501.svg";